var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.318726 22C0.318726 21.6685 0.451869 21.3505 0.688866 21.1161C0.925862 20.8817 1.2473 20.75 1.58246 20.75H26.8572C27.1924 20.75 27.5138 20.8817 27.7508 21.1161C27.9878 21.3505 28.1209 21.6685 28.1209 22C28.1209 22.3315 27.9878 22.6495 27.7508 22.8839C27.5138 23.1183 27.1924 23.25 26.8572 23.25H1.58246C1.2473 23.25 0.925862 23.1183 0.688866 22.8839C0.451869 22.6495 0.318726 22.3315 0.318726 22ZM0.318726 12C0.318726 11.6685 0.451869 11.3505 0.688866 11.1161C0.925862 10.8817 1.2473 10.75 1.58246 10.75H26.8572C27.1924 10.75 27.5138 10.8817 27.7508 11.1161C27.9878 11.3505 28.1209 11.6685 28.1209 12C28.1209 12.3315 27.9878 12.6495 27.7508 12.8839C27.5138 13.1183 27.1924 13.25 26.8572 13.25H1.58246C1.2473 13.25 0.925862 13.1183 0.688866 12.8839C0.451869 12.6495 0.318726 12.3315 0.318726 12ZM0.318726 2C0.318726 1.66848 0.451869 1.35054 0.688866 1.11612C0.925862 0.881696 1.2473 0.75 1.58246 0.75H26.8572C27.1924 0.75 27.5138 0.881696 27.7508 1.11612C27.9878 1.35054 28.1209 1.66848 28.1209 2C28.1209 2.33152 27.9878 2.64946 27.7508 2.88388C27.5138 3.1183 27.1924 3.25 26.8572 3.25H1.58246C1.2473 3.25 0.925862 3.1183 0.688866 2.88388C0.451869 2.64946 0.318726 2.33152 0.318726 2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.c25b798b2277ed5f3fbd4da4c2f2308c.svg";
export { ForwardRef as ReactComponent };